import { navigateToBoardView } from 'app/src/navigateToBoardView';
import { boardPageState } from './useBoardPageState';

export const returnToBoard = () => {
  navigateToBoardView({
    routeParams: {
      // @ts-expect-error
      view: boardPageState.value.view,
    },
    navigateOptions: {
      trigger: true,
    },
  });
};
